import { getToken, modifyUsersList } from "../../helper/common";
import trimmedValues from "../../helper/trimmer";
import { SET_CURRENT_PROFILE } from "../auth/login/actionTypes";
import { clearForm } from "../form/actions";
import agent from "../services/agent";
import { showSnackbarStatus } from "../snackbar/actions";
import {
  CHANGE_PASSWORD_ERROR,
  CHANGE_PASSWORD_FORM,
  CHANGE_PASSWORD_PENDING,
  CHANGE_PASSWORD_SUCCESS,
  CLEAR_CHANGE_PASSWORD_ERROR,
  CLEAR_DELETE_ACCOUNT_ERROR,
  CLEAR_DELETE_OTHERS_ACCOUNT_ERROR,
  CLEAR_DELETE_SELF_ACCOUNT_ERROR,
  CLEAR_DIRECT_CHANGE_PASSWORD_ERROR,
  CLEAR_SEND_RESET_PASSWORD_ERROR,
  CLEAR_TRANSFER_DEVICE_ERROR,
  CLEAR_TRANSFER_USER_ERROR,
  CLEAR_UPDATE_ORG_PREFERENCE_ERROR,
  CLEAR_UPDATE_USER_ERROR,
  CLEAR_USER_DETAILS_ERROR,
  CLOSE_CHANGE_PASSWORD_MODAL,
  CLOSE_DIRECT_CHANGE_PASSWORD_MODAL,
  CLOSE_EDIT_USER_MODAL,
  CLOSE_ORG_PREFERENCE,
  CLOSE_TRANSFER_DEVICE_MODAL,
  DELETE_ACCOUNT_ERROR,
  DELETE_ACCOUNT_PENDING,
  DELETE_OTHERS_ACCOUNT_ERROR,
  DELETE_OTHERS_ACCOUNT_PENDING,
  DELETE_SELF_ACCOUNT_ERROR,
  DELETE_SELF_ACCOUNT_PENDING,
  DIRECT_CHANGE_PASSWORD_ERROR,
  DIRECT_CHANGE_PASSWORD_FORM,
  DIRECT_CHANGE_PASSWORD_PENDING,
  OPEN_CHANGE_PASSWORD_MODAL,
  OPEN_DIRECT_CHANGE_PASSWORD_MODAL,
  OPEN_EDIT_USER_MODAL,
  OPEN_ORG_PREFERENCE,
  OPEN_TRANSFER_DEVICE_MODAL,
  ORG_PREFERENCE,
  SEND_RESET_PASSWORD_ERROR,
  SEND_RESET_PASSWORD_PENDING,
  SEND_RESET_PASSWORD_SUCCESS,
  SET_ASSIGNABLE_TRANSFER_USERS_LIST_ASYNC,
  // SET_LOADING,
  SET_SUBORDINATES_USERS_LIST_ASYNC,
  TRANSFER_DEVICE_ERROR,
  TRANSFER_DEVICE_PENDING,
  TRANSFER_DEVICE_SUCCESS,
  TRANSFER_USER_ERROR,
  TRANSFER_USER_PENDING,
  TRANSFER_USER_SUCCESS,
  TRASFER_USERS_FORM,
  UPDATE_ORG_PREFERENCE_ERROR,
  UPDATE_USER_ERROR,
  UPDATE_USER_PENDING,
  UPDATE_USER_SUCCESS,
  USER_DETAILS,
  USER_DETAILS_ERROR,
  USER_DETAILS_PENDING,
  USER_DETAILS_SUCCESS
} from "./actionTypes";
import { logoutUser } from "../actions";

//----------------------------------------USER-DETAILS--------------------------------------------------------------------------------------------
export const userDetailsPending = () => ({
  type: USER_DETAILS_PENDING,
});

export const setUserDetails = (user) => ({
  type: USER_DETAILS,
  payload: { user },
});

export const userDetailsError = (errorMessage) => ({
  type: USER_DETAILS_ERROR,
  payload: { errorMessage },
});
export const clearUserDetailsError = () => ({
  type: CLEAR_USER_DETAILS_ERROR,
});

export const userDetailsSuccess = () => ({
  type: USER_DETAILS_SUCCESS,
});

export const getUserDetails = (userId) => (dispatch) => {
  dispatch(userDetailsPending());
  // dispatch(setLoading(true))
  getToken(dispatch).then((accessToken) => {
    agent.User.getUserDetails(accessToken, userId)
      .then((userDetails) => {
        dispatch(setUserDetails(userDetails));
        dispatch(userDetailsSuccess());
        dispatch(clearUserDetailsError());
        // dispatch(setLoading(false))
      })
      .catch((err) => {
        if (err && err.response) {
          const message = err.response.body.message ? err.response.body.message : err.response.body.error.message;
          dispatch(userDetailsError(message));
          return;
        }
        else {
          const message = "Network error";
          dispatch(userDetailsError(message));
        }
        console.log("setUserDetails server error", err);
      });
  });
};

//----------------------------------------USER-UPDATE--------------------------------------------------------------------------------------------
export const openEditUserModal = () => ({
  type: OPEN_EDIT_USER_MODAL,
});

export const closeEditUserModal = () => ({
  type: CLOSE_EDIT_USER_MODAL,
});

export const updateUserPending = () => ({
  type: UPDATE_USER_PENDING,
});

export const updateUserSuccess = () => ({
  type: UPDATE_USER_SUCCESS,
});

export const updateUserError = (errorMessage) => ({
  type: UPDATE_USER_ERROR,
  payload: { errorMessage },
});

export const clearUpdateUserError = () => ({
  type: CLEAR_UPDATE_USER_ERROR,
});

export const updateUser = (user) => (dispatch) => {
  const updateUser = {
    ...user,
    zone: user.selected_zone && user.selected_zone.value,
    state: user.selected_state && user.selected_state.value,
  };
  const values = trimmedValues(updateUser)
  dispatch(updateUserPending());
  // dispatch(setLoading(true))
  getToken(dispatch).then((accessToken) => {
    agent.User.updateUser(accessToken, values)
      .then((userId) => {
        dispatch(clearUpdateUserError());
        dispatch(updateUserSuccess());
        dispatch(closeEditUserModal());
        dispatch(getUserDetails(userId));
        dispatch(showSnackbarStatus("User details updated successfully"));
        // dispatch(setLoading(false))
      })
      .catch((err) => {
        if (err && err.response) {
          const message = err.response.body.message ? err.response.body.message : err.response.body.error.message;
          dispatch(updateUserError(message));
          return;
        }
        else {
          const message = "Network error";
          dispatch(updateUserError(message));
        }
        console.log("Update user server error", err);
        dispatch(showSnackbarStatus("Something went wrong. Please try again later"));
      });
  });
};

//----------------------------------------RESET-PASSWORD--------------------------------------------------------------------------------------------
export const sendResetPasswordPending = () => ({
  type: SEND_RESET_PASSWORD_PENDING,
});

export const sendResetPasswordSuccess = () => ({
  type: SEND_RESET_PASSWORD_SUCCESS,
});

export const sendResetPasswordError = (errorMessage) => ({
  type: SEND_RESET_PASSWORD_ERROR,
  payload: { errorMessage }
});
export const clearSendResetPasswordError = () => ({
  type: CLEAR_SEND_RESET_PASSWORD_ERROR,
});

export const sendResetPasswordEmail = (email) => (dispatch) => {
  dispatch(sendResetPasswordPending());
  agent.User.sendResetPasswordEmail(email)
    .then(() => {
      dispatch(sendResetPasswordSuccess());
      dispatch(clearSendResetPasswordError());
      dispatch(showSnackbarStatus("Password reset link sent successfully."));
    })
    .catch((err) => {
      if (err && err.response) {
        const message = err.response.body.message ? err.response.body.message : err.response.body.error.message;
        dispatch(sendResetPasswordError(message));
      }
      else {
        const message = "Network error";
        dispatch(sendResetPasswordError(message));
      }
      console.log("setUserDetails server error", err);
      dispatch(showSnackbarStatus("Something went wrong. Please try again later"));
    });
};

//----------------------------------------CHANGE-PASSWORD--------------------------------------------------------------------------------------------
export const changePasswordForm = (passwordForm) => ({
  type: CHANGE_PASSWORD_FORM,
  payload: { passwordForm }
})

export const openChangePasswordModal = () => ({
  type: OPEN_CHANGE_PASSWORD_MODAL,
});

export const closeChangePasswordModal = () => ({
  type: CLOSE_CHANGE_PASSWORD_MODAL,
});

export const changePasswordPending = () => ({
  type: CHANGE_PASSWORD_PENDING,
});

export const changePasswordSuccess = () => ({
  type: CHANGE_PASSWORD_SUCCESS,
});

export const changePasswordError = (errorMessage) => ({
  type: CHANGE_PASSWORD_ERROR,
  payload: { errorMessage },
});

export const clearChangePasswordError = () => ({
  type: CLEAR_CHANGE_PASSWORD_ERROR,
});

export const changePassword = () => (dispatch, getState) => {
  const currentState = getState();
  const { userdetails } = currentState;
  const { passwordForm } = userdetails;

  if (!passwordForm) {
    dispatch(changePasswordError("Please fill required details."));
    return;
  }

  const changePasswordData = {
    oldPassword: passwordForm.currentPassword,
    newPassword: passwordForm.newPassword,
    confirmNewPassword: passwordForm.confirmNewPassword,
  };

  const values = trimmedValues(changePasswordData)
  dispatch(changePasswordPending());
  getToken(dispatch).then((accessToken) => {
    agent.User.changePassword(accessToken, values)
      .then(() => {
        dispatch(clearChangePasswordError());
        dispatch(changePasswordSuccess());
        dispatch(closeChangePasswordModal());
        dispatch(showSnackbarStatus("Password changed successfully"));
      })
      .catch((err) => {
        if (err && err.response) {
          const message = err.response.body.message ? err.response.body.message : err.response.body.error.message;
          dispatch(changePasswordError(message));
          return;
        }
        else {
          const message = "Network error";
          dispatch(changePasswordError(message));
        }
        console.log("changePassword server error", err);
        dispatch(showSnackbarStatus("Something went wrong. Please try again later"));
      });
  });
};

//----------------------------------------TRANSFER-DEVICES--------------------------------------------------------------------------------------------
export const transferUsersForm = (transferForm) => ({
  type: TRASFER_USERS_FORM,
  payload: { transferForm },
});

export const transferDevicePending = () => ({
  type: TRANSFER_DEVICE_PENDING,
});

export const transferDeviceSuccess = () => ({
  type: TRANSFER_DEVICE_SUCCESS,
});

export const transferDeviceError = (errorMessage) => ({
  type: TRANSFER_DEVICE_ERROR,
  payload: { errorMessage },
});

export const clearTransferDeviceError = () => ({
  type: CLEAR_TRANSFER_DEVICE_ERROR,
});

export const transferUserPending = () => ({
  type: TRANSFER_USER_PENDING,
});

export const transferUserSuccess = () => ({
  type: TRANSFER_USER_SUCCESS,
});

export const transferUserError = (errorMessage) => ({
  type: TRANSFER_USER_ERROR,
  payload: { errorMessage },
});

export const clearTransferUserError = () => ({
  type: CLEAR_TRANSFER_USER_ERROR,
});

export const closeTransferDeviceModal = () => ({
  type: CLOSE_TRANSFER_DEVICE_MODAL,
});

export const openTransferDeviceModal = () => ({
  type: OPEN_TRANSFER_DEVICE_MODAL,
});

const setAssignableTranferUsersForAsyncSelect = (usersList, searchValue) => ({
  type: SET_ASSIGNABLE_TRANSFER_USERS_LIST_ASYNC,
  payload: { usersListAsync: usersList, searchValueAsync: searchValue },
});

const setSubordinatesUsersAsyncSelect = (usersList, searchValue) => ({
  type: SET_SUBORDINATES_USERS_LIST_ASYNC,
  payload: { usersListAsync: usersList, searchValueAsync: searchValue },
});

// const setCurrentUserUnAssignedDevicesListForAsyncSelect = (devicesList, searchValue) => ({
//   type: SET_CURRENT_USER_UNASSIGNED_DEVICE_LIST_ASYNC,
//   payload: { devicesListAsync: devicesList, searchValueAsync: searchValue },
// });

export const transferDevices = (userId, transferForm) => (dispatch) => {
  if (!transferForm) {
    dispatch(transferDeviceError("Please fill required details."));
    return;
  }

  const transferDeviceData = {
    currentUserId: userId,
    targetUserId: transferForm.selected_user && transferForm.selected_user.value,
    type: transferForm.selection,
    deviceIds: transferForm.selected_devices ? transferForm.selected_devices.map((item) => item["value"]) : ['all']
  };

  dispatch(transferDevicePending());
  getToken(dispatch).then((accessToken) => {
    agent.Device.transferDevices(accessToken, transferDeviceData)
      .then((response) => {
        dispatch(clearTransferDeviceError());
        const { errors } = response;
        let errorMessage = "";
        if (errors && Object.keys(errors).length !== 0) {
          Object.entries(errors).forEach((obj) => {
            const [key, value] = obj;
            const deviceArray = value && value.split(',');

            if (key === "invalid_serial_number") {
              errorMessage += (deviceArray && deviceArray.length) > 1 ? `Serial numbers ${value} are invalid. \n` : `Serial number ${value} is invalid. \n`;
            }
            else if (key === "device_key_not_assigned_to_your_org") {
              errorMessage += (deviceArray && deviceArray.length) > 1 ? `Devices ${value} have not been assigned to your organization. \n` : `Device ${value} has not been assigned to your organization. \n`;
            }
            else if (key === "device_already_assigned") {
              errorMessage += (deviceArray && deviceArray.length) > 1 ? `Devices ${value} have already been assigned. \n` : `Device ${value} has already been assigned. \n`;
            }
            else if (key === "master_or_slave_device_cannot_transfer") {
              errorMessage += (deviceArray && deviceArray.length) > 1 ? `The given devices ${value} cannot be transferred, possibly because it were a master or slave devices. \n` : `The given device ${value} cannot be transferred, possibly because it was a master or slave device. \n`;
            }
            else if (key === "inactive_devices") {
              errorMessage += (deviceArray && deviceArray.length) > 1 ? `Devices ${value} are inactive. \n` : `Device ${value} is inactive. \n`;
            }
          });
          dispatch(transferDeviceError(errorMessage));
          return;
        }
        dispatch(transferDeviceSuccess());
        dispatch(closeTransferDeviceModal());
        dispatch(getUserDetails(userId));
        dispatch(showSnackbarStatus("Devices Transferred successfully"));
      })
      .catch((err) => {
        if (err && err.response) {
          const message = err.response.body.message ? err.response.body.message : err.response.body.error.message;
          dispatch(transferDeviceError(message));
          return;
        }
        else {
          const message = "Network error";
          dispatch(transferDeviceError(message));
        }
        console.log("changePassword server error", err);
        dispatch(showSnackbarStatus("Something went wrong. Please try again later"));
      });
  });
};

export const transferUsers = (userId, transferForm) => (dispatch) => {
  if (!transferForm) {
    dispatch(transferUserError("Please fill required details."));
    return;
  }

  const transferUserData = {
    currentUserId: userId,
    targetUserId: transferForm.selected_user && transferForm.selected_user.value,
    type: transferForm.selection,
    userIds: transferForm.selected_users ? transferForm.selected_users.map((item) => item["value"]) : ['all']
  };

  const values = trimmedValues(transferUserData)
  dispatch(transferUserPending());
  getToken(dispatch).then((accessToken) => {
    agent.User.transferUsers(accessToken, values)
      .then((response) => {
        dispatch(clearTransferUserError());
        const { errors } = response;
        let errorMessage = "";
        if (errors && Object.keys(errors).length !== 0) {
          Object.entries(errors).forEach((obj) => {
            const [key, value] = obj;
            const deviceArray = value && value.split(',');

            if (key === "invalid_serial_number") {
              errorMessage += (deviceArray && deviceArray.length) > 1 ? `Serial numbers ${value} are invalid. \n` : `Serial number ${value} is invalid. \n`;
            }
            else if (key === "device_key_not_assigned_to_your_org") {
              errorMessage += (deviceArray && deviceArray.length) > 1 ? `Devices ${value} have not been assigned to your organization. \n` : `Device ${value} has not been assigned to your organization. \n`;
            }
            else if (key === "device_already_assigned") {
              errorMessage += (deviceArray && deviceArray.length) > 1 ? `Devices ${value} have already been assigned. \n` : `Device ${value} has already been assigned. \n`;
            }
            else if (key === "inactive_devices") {
              errorMessage += (deviceArray && deviceArray.length) > 1 ? `Devices ${value} are inactive. \n` : `Device ${value} is inactive. \n`;
            }
          });
          dispatch(transferUserError(errorMessage));
          return;
        }
        dispatch(transferUserSuccess());
        dispatch(clearForm());
        dispatch(closeTransferDeviceModal());
        dispatch(showSnackbarStatus("Users Transferred successfully"));
      })
      .catch((err) => {
        if (err && err.response) {
          const message = err.response.body.message ? err.response.body.message : err.response.body.error.message;
          dispatch(transferUserError(message));
          return;
        }
        else {
          const message = "Network error";
          dispatch(transferUserError(message));
        }
        console.log("changePassword server error", err);
        dispatch(showSnackbarStatus("Something went wrong. Please try again later"));
      });
  });
};

export const getSubordinatesUsersAsyncSelect = (organisationId, userId, searchValue, callback) => (dispatch) => {
  getToken(dispatch).then((accessToken) => {
    agent.User.getSubordinates(accessToken, organisationId, userId)
      .then((userList) => {
        let userListOptions = modifyUsersList(userList);
        let filteredUserList;
        if (searchValue) {
          filteredUserList = userListOptions && userListOptions.filter((user) => user && user.label && user.label.includes(searchValue))
        }
        else {
          filteredUserList = userListOptions;
        }
        dispatch(setSubordinatesUsersAsyncSelect(filteredUserList));
        callback && callback(filteredUserList);
      })
      .catch((err) => {
        console.log("getSubordinatesUsersAsyncSelect for dropdown server error", err);
        dispatch(showSnackbarStatus("Something went wrong. Please try again later"));
        callback && callback();
      });
  });
};

export const getAssignableTranferUsersAsyncSelect = (userId, organisationId, searchValue, callback) => (dispatch) => {
  getToken(dispatch).then((accessToken) => {
    agent.User.getAssignableTransferUser(accessToken, userId, organisationId)
      .then((userList) => {
        let userListOptions = modifyUsersList(userList);
        let filteredUserList;
        if (searchValue) {
          filteredUserList = userListOptions && userListOptions.filter((user) => user && user.label && user.label.includes(searchValue))
        }
        else {
          filteredUserList = userListOptions;
        }
        dispatch(setAssignableTranferUsersForAsyncSelect(filteredUserList));
        callback && callback(filteredUserList);
      })
      .catch((err) => {
        console.log("getAssignableTranferUsers for dropdown server error", err);
        dispatch(showSnackbarStatus("Something went wrong. Please try again later"));
        callback && callback();
      });
  });
};

//----------------------------------------ORG-PREFERENCE--------------------------------------------------------------------------------------------
export const openChangeOrgPreference = () => ({
  type: OPEN_ORG_PREFERENCE,
});

export const closeChangeOrgPreference = () => ({
  type: CLOSE_ORG_PREFERENCE,
});

const setOrgPreference = (orgPreference) => ({
  type: ORG_PREFERENCE,
  payload: { orgPreference },
});

const updateOrgPreferenceError = (errorMessage) => ({
  type: UPDATE_ORG_PREFERENCE_ERROR,
  payload: { errorMessage },
});
const clearUpdateOrgPreferenceError = (errorMessage) => ({
  type: CLEAR_UPDATE_ORG_PREFERENCE_ERROR,
  payload: { errorMessage },
});

const setCurrentProfile = (currentProfile) => ({
  type: SET_CURRENT_PROFILE,
  payload: { currentProfile },
});

export const getOrgPreference = () => (dispatch) => {
  dispatch(userDetailsPending());
  // dispatch(setLoading(true))
  getToken(dispatch).then((accessToken) => {
    agent.User.getOrgPreference(accessToken)
      .then((result) => {
        dispatch(setOrgPreference(result));
        dispatch(userDetailsSuccess());
        dispatch(clearUserDetailsError());
        // dispatch(setLoading(false))
      })
      .catch((err) => {
        if (err && err.response) {
          const message = err.response.body.message ? err.response.body.message : err.response.body.error.message;
          dispatch(userDetailsError(message));
          return;
        }
        else {
          const message = "Network error";
          dispatch(userDetailsError(message));
        }
        console.log("setUserDetails server error", err);
      });
  });
};

export const updateOrgPreference = (formFields, userId) => (dispatch) => {

  const values = trimmedValues(formFields)
  getToken(dispatch).then((accessToken) => {
    agent.User.updateOrgPreference(accessToken, values)
      .then(() => {
        dispatch(getOrgPreference());
        dispatch(updateProfile());
        dispatch(closeChangeOrgPreference());
        dispatch(clearUpdateOrgPreferenceError());
        dispatch(showSnackbarStatus("Organization preference changed successfully."));
      })
      .catch((err) => {
        if (err && err.response) {
          const message = err.response.body.message ? err.response.body.message : err.response.body.error.message;
          dispatch(updateOrgPreferenceError(message));
          return;
        }
        else {
          const message = "Network error";
          dispatch(updateOrgPreferenceError(message));
        }
        console.log("setOrgPreference server error", err);
        dispatch(showSnackbarStatus("Something went wrong. Please try again later"));
      });
  })
};

export const updateProfile = () => (dispatch) => {
  getToken(dispatch).then((accessToken) => {
    agent.Auth.getCurrentUser(accessToken)
      .then((currentUser) => {
        dispatch(setCurrentProfile(currentUser));
      })
  })
}

//----------------------------------------------------DIRECT-PASSWORD-CHANGE---------------------------------------------------------------------------

export const directChangePasswordForm = (passwordForm) => ({
  type: DIRECT_CHANGE_PASSWORD_FORM,
  payload: { passwordForm }
})
export const openDirectChangePasswordModal = () => ({
  type: OPEN_DIRECT_CHANGE_PASSWORD_MODAL,
})
export const closeDirectChangePasswordModal = () => ({
  type: CLOSE_DIRECT_CHANGE_PASSWORD_MODAL,
})
export const directChangePasswordPending = () => ({
  type: DIRECT_CHANGE_PASSWORD_PENDING,
})
export const directChangePasswordError = (errorMessage) => ({
  type: DIRECT_CHANGE_PASSWORD_ERROR,
  payload: { errorMessage }
})
export const clearDirectChangePasswordError = () => ({
  type: CLEAR_DIRECT_CHANGE_PASSWORD_ERROR,
})

export const directChangePassword = () => (dispatch, getState) => {
  const currentState = getState();
  const { userdetails } = currentState;
  const { directPasswordForm } = userdetails;

  if (!directPasswordForm) {
    dispatch(directChangePasswordError("Please fill required details."));
    return;
  }
  const directChangePasswordData = {
    UserId: directPasswordForm.userId,
    NewPassword: directPasswordForm.newPassword,
    ConfirmPassword: directPasswordForm.confirmNewPassword,
  };

  const values = trimmedValues(directChangePasswordData)
  dispatch(directChangePasswordPending());
  getToken(dispatch).then((accessToken) => {
    agent.User.directChangePassword(accessToken, values)
      .then(() => {
        dispatch(clearDirectChangePasswordError());
        dispatch(closeDirectChangePasswordModal());
        dispatch(showSnackbarStatus("Password changed successfully"));
      })
      .catch((err) => {
        if (err && err.response) {
          const message = err.response.body.message ? err.response.body.message : err.response.body.error.message;
          dispatch(directChangePasswordError(message));
          return;
        }
        else {
          const message = "Network error";
          dispatch(directChangePasswordError(message));
        }
        console.log("changePassword server error", err);
        dispatch(showSnackbarStatus("Something went wrong. Please try again later"));
      });
  });
};

//----------------------------------------DELETE-SELF-ACCOUNT--------------------------------------------------------------------------------------------
export const deleteSelfAccountPending = () => ({
  type: DELETE_SELF_ACCOUNT_PENDING,
});

export const deleteSelfAccountError = (errorMessage) => ({
  type: DELETE_SELF_ACCOUNT_ERROR,
  payload: { errorMessage },
});

export const clearDeleteSelfAccountError = () => ({
  type: CLEAR_DELETE_SELF_ACCOUNT_ERROR,
});

export const deleteSelfAccount = () => (dispatch) => {
  dispatch(deleteSelfAccountPending());
  getToken(dispatch).then((accessToken) => {
    agent.User.deleteSelfAccount(accessToken)
      .then(() => {
        dispatch(clearDeleteSelfAccountError());
        dispatch(showSnackbarStatus("Account deleted successfully"));
        dispatch(logoutUser());
      })
      .catch((err) => {
        if (err && err.response) {
          const message = err.response.body.message ? err.response.body.message : err.response.body.error.message;
          dispatch(deleteSelfAccountError(message));
          return;
        }
        else {
          const message = "Network error";
          dispatch(deleteSelfAccountError(message));
        }
        console.log("changePassword server error", err);
        dispatch(showSnackbarStatus("Something went wrong. Please try again later"));
      });
  });
};
//----------------------------------------DELETE-OTHERS'-ACCOUNT--------------------------------------------------------------------------------------------
export const deleteOthersAccountPending = () => ({
  type: DELETE_OTHERS_ACCOUNT_PENDING,
});

export const deleteOthersAccountError = (errorMessage) => ({
  type: DELETE_OTHERS_ACCOUNT_ERROR,
  payload: { errorMessage },
});

export const clearDeleteOthersAccountError = () => ({
  type: CLEAR_DELETE_OTHERS_ACCOUNT_ERROR,
});

export const deleteOthersAccount = (selectedUserId) => (dispatch) => {
  dispatch(deleteOthersAccountPending());
  return getToken(dispatch).then((accessToken) => {
    return agent.User.deleteOthersAccount(accessToken, selectedUserId)
      .then(() => {
        dispatch(clearDeleteOthersAccountError());
        dispatch(showSnackbarStatus("Account deleted successfully"));
        return Promise.resolve(true)
      })
      .catch((err) => {
        if (err && err.response) {
          const message = err.response.body.message ? err.response.body.message : err.response.body.error.message;
          dispatch(deleteOthersAccountError(message));
          return;
        }
        else {
          const message = "Network error";
          dispatch(deleteOthersAccountError(message));
        }
        console.log("changePassword server error", err);
        dispatch(showSnackbarStatus("Something went wrong. Please try again later"));
      });
  });
};